import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17f37335"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-10" }
const _hoisted_2 = {
  key: 0,
  class: "pb-4"
}
const _hoisted_3 = { class: "popUpWrapper" }
const _hoisted_4 = { class: "cursor-pointer" }
const _hoisted_5 = { class: "pb-2 noline w-full" }
const _hoisted_6 = { class: "dropdown" }
const _hoisted_7 = { class: "flex pb-2 overflow-x-auto gap-2 max-w-full show-scroll" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = {
  key: 1,
  class: "whitespace-nowrap"
}
const _hoisted_12 = { class: "openingOpacityText text-sm whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ResourceLabel = _resolveComponent("ResourceLabel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showTitle || _ctx.showTitle === undefined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.getBeautifyDate()), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mergedCourts, (court, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "text-left"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", null, [
                _createVNode(_component_ResourceLabel, {
                  sport: _ctx.sport,
                  data: court,
                  showName: !_ctx.groupResources,
                  isBooking: _ctx.isBooking
                }, null, 8, ["sport", "data", "showName", "isBooking"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(court.courtPrices, (option, optionIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: optionIndex,
                  onClick: ($event: any) => (_ctx.selectDuration($event, option.duration, court.id)),
                  class: _normalizeClass([{
                        selected: option.duration === _ctx.durationSelected && court.id === _ctx.resourceSelectedId,
                      }, "flex flex-col justify-center items-center optionButton md:p-4 sm:p-4 relative cursor-pointer w-fit shrink-0 text-center"])
                }, [
                  (option.withoutTaxes)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("span", {
                          innerHTML: _ctx.Format.addTaxString(option.amountStr)
                        }, null, 8, _hoisted_10)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(option.amountStr), 1)),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(option.duration + " " + _ctx.$t("min")), 1)
                ], 10, _hoisted_8))
              }), 128))
            ])
          ])
        ]))
      }), 128))
    ]),
    (
        _ctx.checkoutOnDurationSelected === false ||
        _ctx.checkoutOnDurationSelected === undefined
      )
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "search-btn flex justify-center items-center m-6 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.checkout()))
        }, _toDisplayString(_ctx.$t("text_continue")), 1))
      : _createCommentVNode("", true)
  ]))
}